import React, { useState } from 'react';
import { Dialog, DialogContent, Grid, Box, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from 'utils/makeStylesAdapter';
import { ButtonConsensus, HeaderModal, InputConsensus } from 'components';
import { toast } from 'react-toastify';
import { colors } from 'utils/colorsSteps';
import { TextField } from '@mui/material';
import movementTaskService from 'services/movement-task/movementTaskService';


const ModalReiterateDeadline = props => {
  const { open, onClose, task } = props;
  const [loading, setLoading] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const initialValues = {
    numberOfDays: 0,
    justification: '',
  };

  const [formState, setFormState] = useState({ ...initialValues });

  const handleConfirmTask = event => {
    event.preventDefault();
    if (!formState.justification) {
      toast.warn('Informe uma justificativa!');
      return;
    }

    if (!formState.numberOfDays) {
      toast.warn('Informe uma data!');
      return;
    }

    setLoading(true);
    movementTaskService.reiterateTaskDeadlineService(task?.task.id, formState).then(() => {
      toast.success('Prazo reiterado com sucesso!');
      setLoading(false);
      onClose();
    }).catch(() => {
      toast.error('Erro ao reiterar prazo!');
      setLoading(false);
    });
  };

  const handleChange = event => {
    setFormState(formState => ({
      ...formState,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={onClose}
        aria-labelledby="responsive-dialog-title"
      >
        <HeaderModal onClose={onClose}>Reiterar Prazo</HeaderModal>
        <DialogContent>
          <form onSubmit={handleConfirmTask}>
            <Grid container spacing={2}>
              <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                <InputConsensus
                  label="Aumento do prazo (em dias):"
                  name="numberOfDays"
                  value={formState.numberOfDays}
                  onChange={handleChange}
                  fullWidth
                  type="number"
                  inputProps={{
                    min: 0,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                <TextField
                  multiline
                  variant="outlined"
                  fullWidth
                  minRows={6}
                  maxRows={10}
                  label="Justificativa"
                  name="justification"
                  value={formState.justification}
                  onChange={handleChange}
                  size="small"
                />
              </Grid>
              <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <ButtonConsensus
                    title="Confirmar"
                    backgroundColor={colors.primary}
                    hovercolor={colors.primary}
                    type="submit"
                    margin={0}
                    disabled={loading}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ModalReiterateDeadline;
